import React from 'react'
import styled from 'styled-components'
import { TelesalesCalendar } from '../../Components/Telesales/TelesalesCalendar/TelesalesCalendar'
import { colors } from '../../Shared/colors'

export const TelesalesCalendarComponent = () => {
  return (
    <Main>
      <TelesalesCalendar />
    </Main>
  )
}

const Main = styled.div`
  background: linear-gradient(135deg, ${colors.lightWhite} 0%, ${colors.inputWhite} 100%);
  min-height: calc(100vh - 10vh);
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
`
